<template>
  <div>
    <el-dialog
      :visible="showDialog"
      width="80%"
      class="chartDia"
      @close="close"
      append-to-body
    >
      <div slot="title" class="slotTit">平台服务费详情</div>
      <div
        style="margin-bottom:15px;color:#666;text-align:left;display:flex;justify-content:space-between;"
      >
        <!-- <span style="color:red;">【平台服务费】计算公式为：项目当月收入×1.0675x平台服务费率。</span> -->
        <span style="color:red;" v-if="define1()">
          【平台服务费】计算公式为：项目当月收入×（1+增值税率）x平台服务费率。
        </span>
        <span style="color:red;" v-if="define2()">
          【平台服务费】计算公式为：终端结算总金额×（1+增值税率）x平台服务费率。
        </span>
        <span style="color:red;" v-if="define3()">
          【平台服务费】计算公式为：终端结算总金额×（1+供应商服务费率）x（1+增值税率）x平台服务费率。
        </span>
      </div>
      <el-table
        v-loading="loading"
        :data="tableData"
        border=""
        style="width: 100%"
        :stripe="true"
        :highlight-current-row="false"
      >
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="taskDt"
          label="任务月度"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="projectName"
          label="项目名"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="项目当月收入"
          v-if="define1()"
        >
          <template slot-scope="{ row }">
            {{ row.projectPayPrice | moneyFixed }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="终端结算总金额"
          v-if="define2() || define3()"
        >
          <template slot-scope="{ row }">
            {{ row.projectPayPrice | moneyFixed }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="供应商服务费率"
          v-if="define3()"
        >
          <template slot-scope="{ row }">
            {{ row.gysSumScale | transScale }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="增值税率"
        >
          <template>6.75%</template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="服务费率"
        >
          <template slot-scope="{ row }">
            {{ row.platformScale | transScale }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="平台服务费"
        >
          <template slot-scope="{ row }">
            {{ row.platformServicesPrice | moneyFixed }}
          </template>
        </el-table-column>
        <template v-if="myrouter === 'finished'">
          <el-table-column align="center" label="操作">
            <template slot-scope="{ row }">
              <el-button type="text" @click="downloadFile(row)">
                下载回单
              </el-button>
            </template>
          </el-table-column>
        </template>
      </el-table>
      <el-button
        @click="close"
        type="primary"
        style="margin:auto;margin-top:20px;display:block;"
      >
        确认
      </el-button>
    </el-dialog>
  </div>
</template>
<script>
import { pageInation } from '@/Mixin/listMixin';
import { platformServicesDetail, alreadyPlatDownBack } from '@/api/ajax';
export default {
  inject: ['itemData'],
  mixins: [pageInation],
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {
      getList: platformServicesDetail, // 获取列表的AJAX
      showDetail: false,
      searchQuery: {
        csoOrderId: this.itemData.data.id
      }
    };
  },
  computed: {
    myrouter() {
      return this.$route.query.activeTask;
    }
  },
  methods: {
    define1() {
      let parent = this.$parent.$parent;
      let chooseType = parent.chooseType;
      if (!chooseType) {
        chooseType = parent.$parent.chooseType;
      }
      if (parent.searchQuery.businessType === 1) {
        return true;
      } else if (parent.searchQuery.businessType === 5 && chooseType === 1) {
        return true;
      } else if (parent.searchQuery.businessType === 7) {
        return true;
      } else {
        return false;
      }
    },
    define2() {
      let parent = this.$parent.$parent;
      if ([3, 4, 6, 8].includes(parent.searchQuery.businessType)) {
        //委托代开,二级灵工,二级个体,二级代开
        return true;
      } else {
        return false;
      }
    },
    define3() {
      let parent = this.$parent.$parent;
      let chooseType = parent.chooseType;
      if (!chooseType) {
        chooseType = parent.$parent.chooseType;
      }
      if (parent.searchQuery.businessType === 2) {
        return true;
      } else if (parent.searchQuery.businessType === 5 && chooseType === 2) {
        return true;
      } else {
        return false;
      }
    },
    close() {
      this.$parent.$parent.componentName = '';
    },
    downloadFile(row) {
      try {
        let a = JSON.parse(localStorage.getItem('activeTask')) || {};
        let { orderServiceId, taskDt } = row;
        let { projectName } = a;
        projectName = projectName || '';
        window.open(
          `${alreadyPlatDownBack}?orderServiceId=${orderServiceId}&projectName=${projectName}&taskDt=${taskDt}`
        );
      } catch (e) {
        console.error(e);
      }
    }
  },
  created() {}
};
</script>
